/*global define, console, window, HTMLImageElement, Promise*/

(function (root, factory) {
    "use strict";
    if (typeof define === 'function' && define.amd) {
        define("ScrollingText", ["jquery", "Behaviors"], factory);
    } else {
        root.ScrollingText = factory(root.jQuery, root.Behaviors);
    }
}(this, function ($, Behaviors) {
    "use strict";
    var module = {};
    function ScrollingText() {
        Behaviors.init(ScrollingText, this, arguments);

        if (jQuery(window).width() > 1020) {
            
            letterCarousel('.ScrollingText','.ScrollingText-section_description');
        
            function letterCarousel(parent_cls,child_cls) {
                jQuery(parent_cls).each(function(){
                    var $this = $(this),
                        e = $this.find(child_cls),
                    t = jQuery(window).height();
                    jQuery(window).on("scroll", function() {
                        if ($this.length) {
                            var t = jQuery(document).scrollTop() + jQuery(window).height(),
                            n = $this.offset().top;
                            
                            if (n <= t) {
                                var i = jQuery(document).scrollTop() - n + jQuery(window).height();
                                var scroll = i - 150;
                                var scroll_slow = scroll + ((scroll/70)/100);
                                if (jQuery(window).width() > 1460) {
                                    var img_scroll = scroll_slow * 55 /100;
                                } else {
                                    var img_scroll = scroll_slow * 20 /100;
                                }
                                e.css({
                                    transform: "translateX(-" + img_scroll + "px)"
                                })
                            }
                        }
                    });
                });
            }
        }
    }

    Behaviors.inherit(ScrollingText, Behaviors.Behavior);

    ScrollingText.QUERY = "[data-ScrollingText-animation]";

    ScrollingText.ELEMENTS = {
        scrollingTextParent: ".ScrollingText",
        scrollingTextItem: ".ScrollingText-section_description_text",
    };
    
    Behaviors.register_behavior(ScrollingText);

    module.ScrollingText = ScrollingText;

    return module;
}));
